'use client'

import GalleryImages from '@/entities/catalog-inside-page/GalleryImages'
import PromoCards from '@/entities/catalog-inside-page/PromoCards'
import PriceItem from '@/entities/catalog-inside-page/PriceItem'
import { useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import EditButton from '@/entities/Admin'

export const ContentItem = ({ product }) => {
    const isSertifikat = product.url === 'podarochnyj-sertifikat'
    // const { inView, ref } = useInView({
    //     threshold: 0,
    //     triggerOnce: true,
    // })
    // console.log(inView);

    const [sampler, setSampler] = useState(null)
    const [sertificatValue, setSertificatValue] = useState(0)

    return (
        <div
            key={product.product_id}
            // ref={ref}
            className={`ContentItem`}
        >
            <EditButton item={'product'} item_id={product.product_id} />{' '}
            {/* админкая кнопка редактировать */}
            <GalleryImages product={product} />
            <div className={'about-item__wrap'}>
                <div className={'about-item__container'}>
                    <div className={'about-item__info'}>
                        <h1>{product.name}</h1>
                        <span>
                            Артикул:{' '}
                            <b className={'about-item__articul'}>
                                {isSertifikat ? 'Сертификат' : product.sku}
                            </b>
                        </span>
                        {!isSertifikat && (
                            <PromoCards productPrice={product.price} />
                        )}
                        {isSertifikat && (
                            <InputGroup
                                className={`SamplerSelect${
                                    product.price <= 0 ||
                                    Number(product.quantity) <= 0
                                        ? ' price-zero'
                                        : ''
                                }`}
                            >
                                <label>Укажите сумму для сертификата:</label>
                                <Form.Control
                                    value={sertificatValue}
                                    style={{
                                        width: 'inherit',
                                        borderRadius: '10px',
                                        minHeight: '50px',
                                    }}
                                    onChange={(e) => {
                                        if (!isNaN(Number(e.target.value))) {
                                            setSertificatValue(
                                                Number(e.target.value)
                                            )
                                        } else {
                                            setSertificatValue(sertificatValue)
                                        }
                                    }}
                                />
                            </InputGroup>
                        )}
                        {!!Object.values(product.options).length &&
                            !isSertifikat && (
                                <InputGroup
                                    className={`SamplerSelect${
                                        product.price <= 0 ||
                                        Number(product.quantity) <= 0
                                            ? ' price-zero'
                                            : ''
                                    }`}
                                >
                                    <label>
                                        Пробник косметики (бесплатно):
                                    </label>
                                    <Form.Select
                                        style={{
                                            width: 'inherit',
                                            borderRadius: '10px',
                                        }}
                                        disabled={product.price <= 0}
                                        onChange={(e) =>
                                            setSampler(e.target.value)
                                        }
                                        defaultValue="dasable"
                                    >
                                        <option value="dasable" disabled>
                                            Выберите
                                        </option>

                                        {Object.values(product.options).map(
                                            (item) => (
                                                <option
                                                    key={item.option_value_id}
                                                    value={
                                                        item.product_option_value_id
                                                    }
                                                >
                                                    {item.name}
                                                </option>
                                            )
                                        )}
                                    </Form.Select>
                                </InputGroup>
                            )}

                        <PriceItem
                            name={product.name}
                            sku={product.sku}
                            quantity={product.quantity}
                            isSertifikat={isSertifikat}
                            sampler={sampler}
                            sertificatValue={sertificatValue}
                            sampler_id={
                                !!Object.values(product.options).length
                                    ? Object.values(product.options)[0]
                                          .product_option_id
                                    : null
                            }
                            specials={
                                product.specials
                                    ? Object.values(product.specials)
                                    : []
                            }
                            productPrice={product.price}
                            productId={product.product_id}
                        />
                    </div>
                    <div className={'about-item__movie'}>
                        {!Object.values(product.videos).length && (
                            <>
                                <div className={'movie'}>
                                    <img
                                        src="/icons/no-video.png"
                                        alt="Иконка нет видео"
                                    />
                                </div>
                                <div className={'movie'}>
                                    <img
                                        src="/icons/no-video.png"
                                        alt="Иконка нет видео"
                                    />
                                </div>
                            </>
                        )}
                        {!!Object.values(product.videos).length &&
                            Object.values(product.videos)
                                .slice(0, 2)
                                .map((item, idx) => {
                                    const urlParam = new URL(item.href)
                                    if (item.href.includes('youtube.com')) {
                                        const videoId =
                                            urlParam.searchParams.get('v')
                                        // https://www.youtube.com/watch?v=GNrdg3PzpJQ&t=13s
                                        return (
                                            <div key={idx} className={'movie'}>
                                                <iframe
                                                    key={videoId}
                                                    width="100%"
                                                    height="100%"
                                                    className={'iframeMovie'}
                                                    src={
                                                        'https://www.youtube.com/embed/' +
                                                        videoId
                                                    }
                                                    style={{
                                                        borderRadius: '10px',
                                                    }}
                                                    title="YouTube video player"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                    allowFullScreen={true}
                                                ></iframe>
                                            </div>
                                        )
                                    }
                                    if (item.href.includes('vk.com')) {
                                        const mas0 = item.href.split('/video')
                                        const mas1 = mas0[1].split('_')

                                        const videoOid = mas1[0]
                                        const videoId = mas1[1]

                                        // https://vk.com/video-211550181_456239101
                                        return (
                                            <div key={idx} className={'movie'}>
                                                <iframe
                                                    src={
                                                        //"https://vk.com/video_ext.php?oid=-211550181&id=456239101&hd=2"
                                                        'https://vk.com/video_ext.php?oid=' +
                                                        videoOid +
                                                        '&id=' +
                                                        videoId +
                                                        '&hd=2'
                                                    }
                                                    width="100%"
                                                    height="100%"
                                                    allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
                                                    allowFullScreen
                                                    style={{
                                                        borderRadius: '10px',
                                                    }}
                                                    title="YouTube video player"
                                                ></iframe>
                                            </div>
                                        )
                                    }
                                })}
                    </div>
                </div>
            </div>
        </div>
    )
}
